export class mdlProposalAddCompRenewalRes {
    public PROPOSALNO: string;
    public INSURED_NAME: string;
    public TOTAL_PREMIUM: number;
    public StatusCode: string;
    public ErrorMsg: string;
    public PMethod: string;
}


// WEBPACK FOOTER //
// D:/GGI/LIMRA_GGI/PROMOSND95/GGI_ONLINE_ANGULAR__2022_10_17_ClaimTracking/src/Models/mdlProposalAddCompRenewalRes.ts